import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { postContact } from "@/lib/api";

// Formulario reutilizable — envía por correo al equipo (incluye la página de origen)
export const ContactForm = ({
  fields,
  sourcePath,
  combo,
  prefill,
  submitLabel = "Enviar",
  successMsg = "¡Recibido! Te escribiremos pronto.",
  accent = "#FF8A80",
  testidPrefix = "form",
}) => {
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (prefill) setValues((v) => ({ ...v, ...prefill }));
  }, [prefill]);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payloadFields = fields.map((f) => ({
        label: f.label,
        value: values[f.name] || "",
      }));
      await postContact({
        sourcePath,
        name: values.nombre || values.contacto || values.empresa || "—",
        email: values.email || "",
        combo,
        fields: payloadFields,
      });
      toast.success(successMsg, { description: "Gracias por sumarte a la aventura." });
      setValues({});
    } catch (err) {
      toast.error(err.message || "No se pudo enviar. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handle} className="space-y-4" data-testid={`${testidPrefix}-form`}>
      {fields.map((f) => (
        <div key={f.name}>
          <label
            className="mb-1.5 block font-mono text-[11px] uppercase tracking-widest text-ink/60"
            htmlFor={`${testidPrefix}-${f.name}`}
          >
            {f.label}
          </label>
          {f.type === "textarea" ? (
            <textarea
              id={`${testidPrefix}-${f.name}`}
              data-testid={`${testidPrefix}-${f.name}`}
              required={f.required !== false}
              rows={4}
              placeholder={f.placeholder}
              value={values[f.name] || ""}
              onChange={(e) => setValues({ ...values, [f.name]: e.target.value })}
              className="w-full resize-none rounded-2xl border border-ink/10 bg-white px-4 py-3 text-ink outline-none transition-all focus:border-transparent focus:ring-2"
              style={{ "--tw-ring-color": accent }}
            />
          ) : (
            <input
              id={`${testidPrefix}-${f.name}`}
              data-testid={`${testidPrefix}-${f.name}`}
              type={f.type || "text"}
              required={f.required !== false}
              placeholder={f.placeholder}
              value={values[f.name] || ""}
              onChange={(e) => setValues({ ...values, [f.name]: e.target.value })}
              className="w-full rounded-2xl border border-ink/10 bg-white px-4 py-3 text-ink outline-none transition-all focus:border-transparent focus:ring-2"
              style={{ "--tw-ring-color": accent }}
            />
          )}
        </div>
      ))}
      <button
        type="submit"
        data-testid={`${testidPrefix}-submit`}
        disabled={loading}
        className="group inline-flex w-full items-center justify-center gap-2 rounded-full px-7 py-3.5 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 disabled:opacity-70"
        style={{ backgroundColor: accent }}
      >
        {loading ? "Enviando..." : submitLabel}
        <Send className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
      </button>
    </form>
  );
};
